import type { AxiosInstance } from 'axios';

/** GET autenticato (Bearer via axios): immagine da storage */
export function siteImageGetPath(siteId: string, isDiagnosisSite: boolean): string {
  const base = isDiagnosisSite ? '/diagnosis-customer-sites' : '/customer-sites';
  return `${base}/${siteId}/image`;
}

function arrayBufferToDataUrl(buffer: ArrayBuffer, mimeType: string): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  const base64 = btoa(binary);
  const mime = mimeType.split(';')[0]?.trim() || 'image/png';
  return `data:${mime};base64,${base64}`;
}

/**
 * Scarica l'immagine con axios (token negli header), restituisce src utilizzabile in <img> (data URL base64).
 */
export async function fetchSiteImageAsDataUrl(
  axiosInstance: AxiosInstance,
  siteId: string,
  isDiagnosisSite: boolean
): Promise<string | null> {
  try {
    const res = await axiosInstance.get<ArrayBuffer>(siteImageGetPath(siteId, isDiagnosisSite), {
      responseType: 'arraybuffer',
    });
    const mime =
      (res.headers['content-type'] as string | undefined) || 'image/png';
    return arrayBufferToDataUrl(res.data, mime);
  } catch {
    return null;
  }
}
